export default __webpack_public_path__ + "static/media/icon_frases_selected.bcdb8b99.svg";